'use client'

import { Header as FractalHeader } from '@snowball-tech/fractal/dist/src/components/Header'

import { type ReactNode } from 'react'

type Props = {
  children?: ReactNode
  className?: string
  left?: ReactNode
  right?: ReactNode
}

export default function ClientHeader({
  children,
  className,
  left,
  right,
}: Props) {
  const handleHeaderClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement
    // Si l'élément cliqué est un lien, un bouton ou tout autre élément interactif, on ne fait pas défiler.
    if (target.closest('a, button, [role="button"]')) {
      return
    }

    const scrollContainer = document.querySelector('#scrollContainer')
    if (scrollContainer) {
      scrollContainer.scrollTo({ behavior: 'smooth', top: 0 })
    }
    window.scrollTo({ behavior: 'smooth', top: 0 })
  }

  return (
    <FractalHeader
      className={className}
      left={left}
      right={right}
      onClick={handleHeaderClick}
    >
      {children}
    </FractalHeader>
  )
}
